import React from "react";
import decisionImg from "./assests/images/quyetdinhxuatban.jpg";

/**
 * Publications page – shows publishing decision and full proceedings
 * Tailwind CSS for styling (assumed configured at project root)
 */
export default function Publications() {
  return (
    <div className="flex flex-col items-center bg-gray-100 min-h-screen w-full p-6 space-y-8">
      {/* Header */}
      <h1 className="mt-5 text-4xl font-bold tracking-wide text-gray-800 border-b-4 border-indigo-500 pb-2">
        Publications
      </h1>

      {/* Publishing Decision */}
      <section className="w-full max-w-4xl bg-white shadow-md rounded-2xl p-6 space-y-4">
        <h2 className="text-xl font-semibold text-gray-700">
          Quyết định xuất bản 
        </h2>
        <p className="italic">NHÀ XUẤT BẢN KHOA HỌC VÀ KỸ THUẬT</p>
        <p className="italic">Chỉ số xuất bản (ISBN): 978‑604‑67‑3280‑8</p>
        <img
          src={decisionImg}
          alt="Publishing Decision"
          className="w-full rounded-xl object-contain shadow"
        />
      </section>

      {/* Proceedings metadata */}
      <section className="w-full max-w-4xl bg-white shadow-md rounded-2xl p-6 space-y-2">
        <h3 className="text-lg font-semibold">FULL PROCEEDINGS</h3>
        <p className="font-bold">
          PROCEEDINGS – The 2024 Conference on Applications of Technology,
          Automation, and Civil Engineering
        </p>
        <p className="italic">ISBN: 978‑604‑67‑3280‑8</p>
        <p className="text-sm text-gray-700">
          <span className="font-medium">Editors:</span> SAIGON TECHNOLOGY UNIVERSITY AIOT LAB VN — Kha Tu
          Huynh, Cao Hao Thi, Tan Duy Le, Thinh Vo Xuan, Khanh Pham, Vi Chi
          Thanh
        </p>
      </section>

      {/* PDF viewer */}
      <section className="w-full max-w-6xl flex flex-col items-center">
      <a
          href="https://drive.google.com/file/d/1hryaYNjiZbGWIPdPR0XTv7xM2GAJja4c/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-indigo-600 hover:bg-indigo-700 mb-5 text-white font-medium py-2 px-4 rounded-lg shadow"
        >
          Click here to download
        </a>
        <embed
          src="./ATAC-Proceedings-ISBN-978-604-67-3280-8.pdf"
          type="application/pdf"
          className="w-full h-[80vh] rounded-xl shadow-xl"
          title="ATAC 2024 Proceedings"
        />
      </section>
    </div>
  );
}
